export default __webpack_public_path__ + "static/media/file-image.36411817.svg";